import React from 'react';
import { styled } from '@components-shared/src/stitches';
import { Modal } from '@components/main-components/modals/Modal';
import { ModalContext } from '@context/modal';

export const RewardsModal = ({
  title,
  description,
  illustration,
}: {
  title?: string;
  description?: string;
  illustration?: React.ReactNode;
}) => {
  const { closeCancelModal } = ModalContext.useContainer();

  const header = (
    <Header>
      <TitleContainer>
        <RewardIllustrationContainer>{illustration}</RewardIllustrationContainer>
        <h2>{title}</h2>
      </TitleContainer>
    </Header>
  );

  const body = <Body>{description}</Body>;

  return <Modal header={header} body={body} closeModal={closeCancelModal} />;
};

const Header = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
});

const TitleContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: 6,

  h2: {
    base: 'M',
    fontStyle: 'semibold',
  },
});

const RewardIllustrationContainer = styled('div', {
  width: 50,
  height: 50,
});

const Body = styled('div', {
  base: 'S',
  color: '$neutral700',
});
